import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {authGuardGuard} from './auth-guard.guard';
import {MainLayoutComponent} from './layout/main-layout/main-layout.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./enrollment/signin/signin.module').then((m) => m.SigninModule)
  },
  {
    path: 'signup',
    loadChildren: () => import('./enrollment/signup/signup.module').then((m) => m.SignupModule)
  },
  {
    path: 'completeProcess/:step/:innerstep',
    loadChildren: () => import('./enrollment/signup/signup.module').then((m) => m.SignupModule)
  },
  {
    path: 'forgot_password',
    loadChildren: () => import('./enrollment/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'dashboard',
        canActivate: [authGuardGuard],
        loadChildren: () => import('../app/dashboard/dashboard.module').then((m) => m.DashboardModule)
      },
      {
        path: 'payment',
        canActivate: [authGuardGuard],
        loadChildren: () => import('./transactions/payment/payment.module').then(m => m.PaymentModule)
      },
      {
        path: 'successful_transaction',
        canActivate: [authGuardGuard],
        loadChildren: () => import('./transactions/transaction-successful/transaction-successful.module').then(m => m.TransactionSuccessfulModule)
      },
      {
        path: 'transfer',
        canActivate: [authGuardGuard],
        loadChildren: () => import('./transactions/transfer/transfer.module').then(m => m.TransferModule)
      },
      {
        path: 'wallet',
        canActivate: [authGuardGuard],
        loadChildren: () => import('../app/wallets/wallets.module').then(m => m.WalletsModule)
      },
      {
        path: 'deposit',
        canActivate: [authGuardGuard],
        loadChildren: () => import('./transactions/deposit/deposit.module').then(m => m.DepositModule)
      },
      {
        path: 'uker',
        canActivate: [authGuardGuard],
        loadChildren: () => import('./ukers/list-ukers/list-ukers.module').then(m => m.ListUkersModule)
      },
      {
        path: 'user/user_detail',
        canActivate: [authGuardGuard],
        loadChildren: () => import('./account/user-detail/user-detail.module').then(m => m.UserDetailModule)
      },
      {
        path: 'user/company_detail',
        canActivate: [authGuardGuard],
        loadChildren: () => import('./account/company-detail/company-detail.module').then(m => m.CompanyDetailModule)
      },
      {
        path: 'user/settings',
        canActivate: [authGuardGuard],
        loadChildren: () => import('./account/settings/settings.module').then(m => m.SettingsModule)
      },
      {
        path: 'transfer_summary',
        canActivate: [authGuardGuard],
        loadChildren: () => import('./transactions/transfer-summary/transfer-summary.module').then(m => m.TransferSummaryModule)
      },
      {
        path: 'bank_account',
        canActivate: [authGuardGuard],
        loadChildren: () => import('./bank-account/bank-account.module').then(m => m.BankAccountModule)
      },
      {
        path: 'stablecoin_wallet',
        canActivate: [authGuardGuard],
        loadChildren: () => import('./stablecoin-wallet/stablecoin-wallet.module').then(m => m.StablecoinWalletModule)
      },
      {
        path: 'withdrawal',
        canActivate: [authGuardGuard],
        loadChildren: () => import('./transactions/withdrawal/withdrawal.module').then(m => m.WithdrawalModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true,
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
